import {TimeagoIntl} from 'ngx-timeago';
import {strings as englishStrings} from 'ngx-timeago/language-strings/en';

export class TimeAgoIntlEn extends TimeagoIntl {
  strings = englishStrings;
}
